import { DateTime } from 'luxon';
// This hook determines whether we have a valid or invalid query param depending on the shift start
export var useIsValidSwapQueryParam = function (_a) {
    var shiftStart = _a.shiftStart;
    return !!shiftStart && DateTime.fromISO(shiftStart).isValid;
};
